import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	itemsListHeader: {
		id: 'business-timeline.timeline-view.list-header.items-list-header',
		defaultMessage: 'Items',
		description: 'Header of the items list in the timeline view',
	},
});
